<template>
  <section>
    <!-- GOALS -->
    <div>
      <div v-for="goal in goals" :key="goal.id" class="flex my-2 goal">
        <button
          type="button"
          @click="toggleGoalComplete(goal)"
          @mouseover="hoveredGoal = goal.id"
          @mouseleave="hoveredGoal = undefined"
          class="mr-2 border focus:outline-none focus:border-blue-400 hover:bg-blue-400 hover:text-white"
          :class="{ 'bg-blue-400': goal.status === 'DONE' }"
        >
          <i
            class="material-icons text-sm"
            :class="{ 'text-white': goal.status === 'DONE' }"
            >{{
              hoveredGoal === goal.id && goal.status === "DONE"
                ? "undo"
                : "done"
            }}</i
          >
        </button>
        <div
          :class="{ 'line-through': goal.status === 'DONE' }"
          class="text-left"
        >
          {{ goal.goal }}
        </div>
        <div class="action-buttons invisible flex">
          <button
            type="button"
            @click="editGoal(goal)"
            class="ml-2 focus:border-gray-400 hover:bg-gray-400 text-gray-400 hover:text-white"
          >
            <i class="material-icons text-sm">edit</i>
          </button>
          <button
            type="button"
            @click="deleteGoal(goal)"
            class="ml-2 focus:border-red-400 hover:bg-gray-400 text-gray-400 hover:text-white"
          >
            <i class="material-icons text-sm">delete</i>
          </button>
        </div>
      </div>
    </div>

    <!-- ADD NEW GOAL MAGIC -->
    <input
      type="text"
      autocomplete="off"
      v-model="newGoal"
      @keyup.enter="addGoal"
      class="form-input mt-4 block w-full text-sm"
      placeholder="What are the biggest actions you can take this week to make the most progress?"
    />
  </section>
</template>

<script>
export default {
  name: "GoalList",
  props: {
    goals: {
      type: Array,
      required: true,
    },
    weekId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      newGoal: "",
      // TODO - UNDO THIS BULLSHIT HACK AND GIVE ME NORMAL CSS
      hoveredGoal: undefined,
    };
  },
  methods: {
    addGoal() {
      if (!this.newGoal || !this.newGoal.length) {
        return;
      }

      this.$store.dispatch("updates/addGoal", {
        goal: this.newGoal,
        weekId: this.weekId,
      });
    },
    deleteGoal(goal) {
      this.$store.dispatch("updates/deleteGoal", {
        weekId: this.weekId,
        goalId: goal.id,
      });
    },
    editGoal(goal) {
      // TODO - UPDATE ME TO USE INLINE EDITING
      const newGoal = prompt(
        "What would you like your new goal to be?",
        goal.goal
      );

      if (newGoal === null) {
        return console.log("Prompt was canceled, goal remains unchanged.");
      }

      if (!newGoal || !newGoal.length) {
        return this.deleteGoal(goal);
      }

      this.$store.dispatch("updates/updateGoal", {
        weekId: this.weekId,
        goalId: goal.id,
        payload: { goal: newGoal },
      });
    },
    toggleGoalComplete(goal) {
      this.$store.dispatch("updates/updateGoal", {
        weekId: this.weekId,
        goalId: goal.id,
        payload: { status: goal.status !== "DONE" ? "DONE" : "PENDING" },
      });
    },
  },
  watch: {
    // RESET EACH TIME A NEW GOAL IS ADDED
    // TODO - DECIDE IF WE CARE ENOUGH TO UNHACK THIS
    goals() {
      this.newGoal = "";
    },
  },
};
</script>

<style lang="postcss" scoped>
button {
  @apply flex items-center justify-center h-6 w-6 rounded-full;
  min-width: 1.5rem;
}
button:focus {
  @apply outline-none;
}

.goal:hover .action-buttons {
  @apply visible;
}
</style>
